<template>
  <b-col>
    <h2>{{title}}</h2>
    <audio ref="audio" id="rain" loop preload>
      <source
        v-for="source in sources"
        v-bind:key="source.url"
        :src="source.url"
        :type="source.type"
      >Sorry, your browser does not support HTML5 audio.
    </audio>
    <b-row>
      <b-col class="col-2">
        <b-form-checkbox :id="uid" type="checkbox" value="rain" v-model="playing">
          <span class="sr-only">Toggle Audio</span>
        </b-form-checkbox>
      </b-col>
      <b-col class="col-10">
        <label class="sr-only" :for="range_uid">Volume</label>
        <b-form-input type="range" :id="range_uid" v-model="volume" min="0" max="100"/>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
let uid = 0;
export default {
  name: "Media",
  props: {
    sources: Array,
    title: String
  },
  data: () => {
    uid += 1;
    return {
      playing: false,
      volume: 100,
      uid: `media-${uid}`,
      range_uid: `range-${uid}`
    };
  },
  watch: {
    playing: function() {
      if (this.playing) {
        this.$refs.audio.play();
      } else {
        this.$refs.audio.pause();
      }
    },
    volume: function() {
      this.$refs.audio.volume = this.volume / 100;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
